import { apiService } from '../services/api';
import { demoService } from '../demo/demoService';
import { useDemo } from '../demo/DemoContext';

export const useApiService = (): typeof apiService => {
  const { isDemo } = useDemo();
  return isDemo ? demoService : apiService;
};
